/* Powerland: promo stickers on Algolia search results and the search dropdown, from /pages/promotions?view=pl-promo-feed */
(function () {
  var KEY = 'plPromoFeed:v2', MAX_AGE = 30 * 60 * 1000, feed = null, loading = false, queued = false;
  var SEL = 'a.ais-inline-hit, a.aa-ItemLink';
  function load(cb) {
    if (feed) return cb();
    try {
      var c = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (c && Date.now() - c.t < MAX_AGE) { feed = c.d; return cb(); }
    } catch (e) {}
    if (loading) return;
    loading = true;
    fetch('/pages/promotions?view=pl-promo-feed', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (t) {
        try { feed = JSON.parse(t); } catch (e) { feed = {}; }
        try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), d: feed })); } catch (e) {}
        cb();
      })
      .catch(function () { feed = {}; });
  }
  function handleOf(href) {
    var m = (href || '').match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]).toLowerCase() : null;
  }
  function decorate() {
    queued = false;
    var links = document.querySelectorAll(SEL);
    if (!links.length) return;
    if (!feed) return load(decorate);
    links.forEach(function (a) {
      if (a.getAttribute('data-pl-stk')) return;
      a.setAttribute('data-pl-stk', '1');
      var list = feed[handleOf(a.getAttribute('href'))];
      if (!list || !list.length) return;
      var box = a.querySelector('.ais-inline-hit__img-wrap, .aa-ItemPicture');
      if (!box) return;
      if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
      var d = document.createElement('div');
      d.className = 'pl-stk ' + (a.classList.contains('aa-ItemLink') ? 'pl-stk--mini' : 'pl-stk--search');
      if (box.querySelector('img[src*="next-day"]')) d.className += ' pl-stk--below';
      d.setAttribute('aria-hidden', 'true');
      list.slice(0, 3).forEach(function (s) {
        var el;
        if (s.s) { el = document.createElement('img'); el.className = 'pl-stk__img'; el.src = s.s; el.alt = s.a || ''; el.loading = 'lazy'; }
        else { el = document.createElement('span'); el.className = 'pl-stk__txt'; el.textContent = s.t || ''; }
        d.appendChild(el);
      });
      box.appendChild(d);
    });
  }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(decorate); } }
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.pl-stk--pdp');
    if (!a) return;
    var t = Array.prototype.find.call(document.querySelectorAll('.pl-pp'), function (x) { return x.offsetParent !== null; });
    if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });
  schedule();
})();
